import { render, staticRenderFns } from "./OrderProductionStatusLabel.vue?vue&type=template&id=3b66c3cf&scoped=true&"
import script from "./OrderProductionStatusLabel.vue?vue&type=script&lang=js&"
export * from "./OrderProductionStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductionStatusLabel.vue?vue&type=style&index=0&id=3b66c3cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b66c3cf",
  null
  
)

export default component.exports